import React, { Component } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css';
import Icon from '../../Components/Icon';
import ModalDialog from '../../Components/ModalDialog';
import IdentityActions, {
   selectMyMfaDetails,
   selectMyMfaDetailsLoading,
   selectRemoveSmsEnrollmentResponse,
   selectRemoveSmsEnrollmentLoading,
   selectRemoveAuthenticatorEnrollmentResponse,
   selectRemoveAuthenticatorEnrollmentLoading,
   selectChangeDefaultMfaMethodResponse,
   selectChangeDefaultMfaMethodLoading,
} from '../../Redux/IdentityRedux';
import { getToken } from '../../Session/SessionRedux';
import './Mfa.scss';
import Loading from '../../Components/Loading';

const identityAuthority = process.env.REACT_APP_IDENTITY_AUTHORITY;

const REMOVE_DIALOG_TITLES = {
   'remove-sms': 'Remove SMS Enrollment',
   'remove-authenticator': 'Remove Authenticator Enrollment',
};

const REMOVE_DIALOG_MESSAGES = {
   'remove-sms':
      'Are you sure you want to remove SMS enrollment from your account?',
   'remove-authenticator':
      'Are you sure you want to remove Authenticator enrollment from your account?',
};

class Mfa extends Component {
   state = {
      pendingRemoveAction: null,
   };

   componentDidMount() {
      const { token, myMfaDetails, dispatch } = this.props;
      if (token && !myMfaDetails) {
         dispatch(IdentityActions.getMyMfaDetailsRequest(token));
      }
   }

   componentDidUpdate(prevProps) {
      const {
         token,
         dispatch,
         removeSmsEnrollmentResponse,
         removeAuthenticatorEnrollmentResponse,
         changeDefaultMfaMethodResponse,
      } = this.props;

      if (
         removeSmsEnrollmentResponse &&
         removeSmsEnrollmentResponse !== prevProps.removeSmsEnrollmentResponse
      ) {
         this.showResultToast(
            removeSmsEnrollmentResponse,
            'SMS enrollment removed successfully.'
         );
         if (removeSmsEnrollmentResponse.success) {
            dispatch(IdentityActions.getMyMfaDetailsRequest(token));
         }
      }

      if (
         removeAuthenticatorEnrollmentResponse &&
         removeAuthenticatorEnrollmentResponse !==
            prevProps.removeAuthenticatorEnrollmentResponse
      ) {
         this.showResultToast(
            removeAuthenticatorEnrollmentResponse,
            'Authenticator enrollment removed successfully.'
         );
         if (removeAuthenticatorEnrollmentResponse.success) {
            dispatch(IdentityActions.getMyMfaDetailsRequest(token));
         }
      }

      if (
         changeDefaultMfaMethodResponse &&
         changeDefaultMfaMethodResponse !==
            prevProps.changeDefaultMfaMethodResponse
      ) {
         this.showResultToast(
            changeDefaultMfaMethodResponse,
            'Default MFA method updated successfully.'
         );
         if (changeDefaultMfaMethodResponse.success) {
            dispatch(IdentityActions.getMyMfaDetailsRequest(token));
         }
      }
   }

   enrollSms = () => {
      const returnUrl = encodeURIComponent(`${window.location.origin}/mfa`);
      window.location.href = `${identityAuthority}/mfa/setup/sms?returnUrl=${returnUrl}&isFromPractitionerWebsite=true`;
   };

   enrollAuthenticator = () => {
      const returnUrl = encodeURIComponent(`${window.location.origin}/mfa`);
      window.location.href = `${identityAuthority}/mfa/setup/authenticator?returnUrl=${returnUrl}&isFromPractitionerWebsite=true`;
   };

   openRemoveDialog = pendingRemoveAction => {
      this.setState({ pendingRemoveAction });
   };

   closeRemoveDialog = () => {
      this.setState({ pendingRemoveAction: null });
   };

   confirmRemove = () => {
      const { token, dispatch } = this.props;
      const { pendingRemoveAction } = this.state;

      if (pendingRemoveAction === 'remove-sms') {
         dispatch(IdentityActions.removeSmsEnrollmentRequest(token));
      } else if (pendingRemoveAction === 'remove-authenticator') {
         dispatch(IdentityActions.removeAuthenticatorEnrollmentRequest(token));
      }

      this.closeRemoveDialog();
   };

   setDefaultMethod = newMethod => {
      const { token, dispatch } = this.props;
      dispatch(IdentityActions.changeDefaultMfaMethodRequest(token, newMethod));
   };

   showResultToast = (response, successMessage) => {
      M.toast({
         html: response.success
            ? successMessage
            : response.message || 'Something went wrong. Please try again.',
         classes: response.success ? 'success' : 'error',
      });
   };

   render() {
   
      const { 
         myMfaDetailsLoading, 
         removeAuthenticatorEnrollmentLoading, 
         removeSmsEnrollmentLoading, 
         changeDefaultMfaMethodLoading 
      } = this.props;

      const { myMfaDetails } = this.props;
      const {
         preferredMfaMethod,
         totpEnrolledDate,
         smsEnrolledDate,
         updatedDate,
      } = myMfaDetails || {};

      const bothEnrolled = !!(totpEnrolledDate && smsEnrolledDate);
      const resetDisabled = !smsEnrolledDate && !totpEnrolledDate;
      const smsDefaultDisabled = !bothEnrolled || preferredMfaMethod === 'SMS';
      const authenticatorDefaultDisabled =
         !bothEnrolled || preferredMfaMethod === 'AUTHENTICATOR';
      const smsRemoveDisabled = !bothEnrolled;
      const authenticatorRemoveDisabled = !bothEnrolled;

      const smsSubtitle = smsEnrolledDate
         ? `Enrolled: ${new Date(smsEnrolledDate).toLocaleDateString()}`
         : 'Not enrolled';
      const authenticatorSubtitle = totpEnrolledDate
         ? `Enrolled: ${new Date(totpEnrolledDate).toLocaleDateString()}`
         : 'Not enrolled';

      const updatedDateDisplay = updatedDate
         ? new Date(updatedDate).toLocaleString()
         : '—';

      const { pendingRemoveAction } = this.state;

      return (
         <>
            <main>
               <Loading isLoading={myMfaDetailsLoading || changeDefaultMfaMethodLoading} overlayOnChildren={true}>
                  <div className="section no-pad-bot" id="index-banner">
                     <div className="container">
                        <div className="row">
                           <div className="col s12 m12 l7 offset-l1" >
                              <div className="row" style={{ marginBottom: 0 }}>
                                 <div className="col l12">
                                    <p className="columnheader">
                                       Multi-Factor Authentication (MFA)
                                    </p>
                                 </div>
                              </div>

                              <div className="row" style={{ marginBottom: 0 }}>
                                 <div className="col l12">
                                    <div className="mfa-explanation-banner">
                                       <Icon
                                          className="mfa-explanation-icon"
                                          iconName="info"
                                       />
                                       <span>
                                          Multi-Factor Authentication helps
                                          protect your account by requiring a
                                          verification code when you sign in.
                                          Use this page to choose and manage
                                          your preferred verification method.
                                       </span>
                                    </div>
                                 </div>
                              </div>

                              <div className="row mfa-info-row">
                                 <div className="col s6">
                                    <span className="mfa-info-label grey2-text">
                                       Preferred Method
                                    </span>
                                    <strong>
                                       {preferredMfaMethod ||
                                          'No preferred method selected'}
                                    </strong>
                                 </div>
                                 <div className="col s6">
                                    <span className="mfa-info-label grey2-text">
                                       Last Updated
                                    </span>
                                    <strong>{updatedDateDisplay}</strong>
                                 </div>
                              </div>

                              <hr />

                              <div className="row">
                                 <div className="col s12 m6">
                                    <div className="card-panel white mfa-method-card">
                                       <div className="mfa-card-title">
                                          <Icon
                                             className="mfa-card-icon"
                                             iconName="sms"
                                          />
                                          <span>SMS</span>
                                          {preferredMfaMethod === 'SMS' && (
                                             <span className="mfa-card-default-badge">
                                                Default
                                             </span>
                                          )}
                                       </div>
                                       <span className="mfa-card-description grey2-text">
                                          Receive a code by text message to
                                          your mobile number.
                                       </span>
                                       <span className="mfa-card-status grey2-text">
                                          <span className="mfa-status-dot" />
                                          {smsSubtitle}
                                       </span>
                                       <hr className="mfa-card-divider" />
                                       <div className="mfa-card-actions">
                                          {!smsEnrolledDate ? (
                                             <button
                                                type="button"
                                                className="mfa-flat-button"
                                                onClick={this.enrollSms}
                                             >
                                                <Icon
                                                   className="mfa-button-icon"
                                                   iconName="person_add"
                                                />
                                                Enrol
                                             </button>
                                          ) : (
                                             <>
                                                <button
                                                   type="button"
                                                   className="mfa-flat-button"
                                                   disabled={smsDefaultDisabled || changeDefaultMfaMethodLoading || myMfaDetailsLoading}
                                                   onClick={() =>
                                                      this.setDefaultMethod(
                                                         'SMS'
                                                      )
                                                   }
                                                >
                                                   <Icon
                                                      className="mfa-button-icon"
                                                      iconName="star"
                                                   />
                                                   Set as Default
                                                </button>
                                                <button
                                                   type="button"
                                                   className="mfa-flat-button"
                                                   disabled={smsRemoveDisabled}
                                                   onClick={() =>
                                                      this.openRemoveDialog(
                                                         'remove-sms'
                                                      )
                                                   }
                                                >
                                                   <Icon
                                                      className="mfa-button-icon"
                                                      iconName="delete"
                                                   />
                                                   Remove
                                                </button>
                                             </>
                                          )}
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col s12 m6">
                                    <div className="card-panel white mfa-method-card mfa-method-card-highlighted">
                                       <div className="mfa-card-title">
                                          <Icon
                                             className="mfa-card-icon"
                                             iconName="security"
                                          />
                                          <span>Authenticator</span>
                                          {preferredMfaMethod ===
                                             'AUTHENTICATOR' && (
                                             <span className="mfa-card-default-badge">
                                                Default
                                             </span>
                                          )}
                                          <span className="mfa-card-recommended-badge">
                                             Recommended
                                          </span>
                                       </div>
                                       <span className="mfa-card-description grey2-text">
                                          Use an authenticator app to generate
                                          a verification code.
                                       </span>
                                       <span className="mfa-card-status grey2-text">
                                          <span className="mfa-status-dot" />
                                          {authenticatorSubtitle}
                                       </span>
                                       <hr className="mfa-card-divider" />
                                       <div className="mfa-card-actions">
                                          {!totpEnrolledDate ? (
                                             <button
                                                type="button"
                                                className="mfa-flat-button"
                                                onClick={
                                                   this.enrollAuthenticator
                                                }
                                             >
                                                <Icon
                                                   className="mfa-button-icon"
                                                   iconName="person_add"
                                                />
                                                Enrol
                                             </button>
                                          ) : (
                                             <>
                                                <button
                                                   type="button"
                                                   className="mfa-flat-button"
                                                   disabled={
                                                      authenticatorDefaultDisabled || changeDefaultMfaMethodLoading || myMfaDetailsLoading
                                                   }
                                                   onClick={() =>
                                                      this.setDefaultMethod(
                                                         'AUTHENTICATOR'
                                                      )
                                                   }
                                                >
                                                   <Icon
                                                      className="mfa-button-icon"
                                                      iconName="star"
                                                   />
                                                   Set as Default
                                                </button>
                                                <button
                                                   type="button"
                                                   className="mfa-flat-button"
                                                   disabled={
                                                      authenticatorRemoveDisabled
                                                   }
                                                   onClick={() =>
                                                      this.openRemoveDialog(
                                                         'remove-authenticator'
                                                      )
                                                   }
                                                >
                                                   <Icon
                                                      className="mfa-button-icon"
                                                      iconName="delete"
                                                   />
                                                   Remove
                                                </button>
                                             </>
                                          )}
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </Loading>
            </main>
            <ModalDialog
               isOpen={!!pendingRemoveAction}
               onRequestClose={this.closeRemoveDialog}
               body={
                  <div className="col l12">
                     <p className="mfa-confirm-title">
                        {pendingRemoveAction &&
                           REMOVE_DIALOG_TITLES[pendingRemoveAction]}
                     </p>
                     <span>
                        {pendingRemoveAction &&
                           REMOVE_DIALOG_MESSAGES[pendingRemoveAction]}
                     </span>
                  </div>
               }
               footer={
                  <div className="col l12 mfa-confirm-actions">
                     <button
                        type="button"
                        className="mfa-flat-button mfa-confirm-cancel"
                        onClick={this.closeRemoveDialog}
                     >
                        Cancel
                     </button>
                     <button
                        type="button"
                        className="mfa-flat-button"
                        onClick={this.confirmRemove}
                     >
                        Remove
                     </button>
                  </div>
               }
            />
         </>
      );
   }
}

const mapStateToProps = state => ({
   myMfaDetails: selectMyMfaDetails(state),
   myMfaDetailsLoading: selectMyMfaDetailsLoading(state),
   token: getToken(state),
   removeSmsEnrollmentResponse: selectRemoveSmsEnrollmentResponse(state),
   removeSmsEnrollmentLoading: selectRemoveSmsEnrollmentLoading(state),
   removeAuthenticatorEnrollmentResponse: selectRemoveAuthenticatorEnrollmentResponse(
      state
   ),
   removeAuthenticatorEnrollmentLoading: selectRemoveAuthenticatorEnrollmentLoading(
      state
   ),
   changeDefaultMfaMethodResponse: selectChangeDefaultMfaMethodResponse(state),
   changeDefaultMfaMethodLoading: selectChangeDefaultMfaMethodLoading(state),
});

export default connect(mapStateToProps)(Mfa);
